import registerLoginScreen from './login';
import registerEnquiryFormScreen from './enquiry-form';
import registerPasswordResetScreen from './password-reset';
import registerSelfRegistrationScreen from './self-registration';
import registerUserPage from './user';

export default function registerScreens(Alpine) {
    registerLoginScreen(Alpine);
    registerEnquiryFormScreen(Alpine);
    registerPasswordResetScreen(Alpine);
    registerSelfRegistrationScreen(Alpine);
    registerUserPage(Alpine);
}
